var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',{ref:"map",staticClass:"map",attrs:{"center":_vm.message.raw.location,"zoom":_vm.zoom},on:{"ready":_vm.ready,"click":_vm.openGoogleMaps}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_vm._v(" "),_c('l-marker',{attrs:{"icon":_vm.icons.default,"lat-lng":_vm.message.raw.location}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eaac068","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/popup-chat/messages/LocationMessage.vue
// module id = +77K
// module chunks = 0